import React from "react";

function CompFallbackLoader() {
    const styles = `
        .comp-fallback-loader {
            --ease-glide: cubic-bezier(.65,0,.35,1);
            --ease-reveal: cubic-bezier(.16,1,.3,1);
            --ease-breath: cubic-bezier(.45,0,.55,1);
            position: fixed;
            inset: 0;
            width: 100vw;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.28);
            backdrop-filter: blur(12px);
            overflow: hidden;
            z-index: 99999;
        }

        .comp-fallback-loader.opener-canvas {
            position: fixed;
            inset: 0;
            width: 100vw;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .comp-fallback-loader .opener-lockup {
            position: relative;
            z-index: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 16px;
        }

        .comp-fallback-loader .opener-mark {
            width: 64px;
            height: 64px;
            flex-shrink: 0;
        }

        .comp-fallback-loader .opener-mark .m-fill {
            fill: var(--jobma-green, #47b072);
            opacity: 0;
        }

        .comp-fallback-loader .opener-mark .m-stroke {
            fill: none;
            stroke: var(--jobma-green, #47b072);
            stroke-width: 2.4;
        }

        .comp-fallback-loader .opener-word {
            height: 38px;
            overflow: visible;
        }

        .comp-fallback-loader .opener-word path {
            opacity: 0;
            transform: translateY(9px);
            fill: var(--jobma-green, #47b072);
        }

        .comp-fallback-loader.opener-group.playing .opener-mark {
            animation: compFallbackMarkScale 2s alternate ease;
            animation-iteration-count: infinite;
        }

        .comp-fallback-loader.opener-group.playing .opener-mark .m-stroke {
            animation: compFallbackMarkDraw 1.3s var(--ease-glide) both 0.15s;
        }

        .comp-fallback-loader.opener-group.playing .opener-mark .m-fill {
            animation: compFallbackMarkFill 1s var(--ease-glide) both 1.25s;
        }

        .comp-fallback-loader.opener-group.playing .glow {
            animation: compFallbackGlowPulse 2s var(--ease-breath) both;
        }

        .comp-fallback-loader.opener-group.playing .opener-word path {
            animation: compFallbackLetterIn 0.62s var(--ease-reveal) both;
        }

        .comp-fallback-loader.opener-group.playing .opener-word path:nth-of-type(1) { animation-delay: 1.95s; }
        .comp-fallback-loader.opener-group.playing .opener-word path:nth-of-type(2) { animation-delay: 2.04s; }
        .comp-fallback-loader.opener-group.playing .opener-word path:nth-of-type(3) { animation-delay: 2.13s; }
        .comp-fallback-loader.opener-group.playing .opener-word path:nth-of-type(4) { animation-delay: 2.22s; }
        .comp-fallback-loader.opener-group.playing .opener-word path:nth-of-type(5) { animation-delay: 2.31s; }

        .comp-fallback-loader .glow {
            position: absolute;
            z-index: 0;
            width: 220px;
            height: 220px;
            border-radius: 50%;
            background: radial-gradient(circle, rgba(126, 221, 166, 0.35), transparent 70%);
            filter: blur(18px);
            opacity: 0;
            pointer-events: none;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }

        @keyframes compFallbackMarkScale {
            0%   { transform: scale(1.5); }
            78%  { transform: scale(1.5); }
            100% { transform: scale(1); }
        }

        @keyframes compFallbackMarkDraw {
            from { stroke-dashoffset: 100; }
            to   { stroke-dashoffset: 0; }
        }

        @keyframes compFallbackMarkFill {
            from { opacity: 0; }
            to   { opacity: 1; }
        }

        @keyframes compFallbackGlowPulse {
            0%   { opacity: 0; }
            40%  { opacity: 0.55; }
            100% { opacity: 0.28; }
        }

        @keyframes compFallbackLetterIn {
            from { opacity: 0; transform: translateY(9px); }
            to   { opacity: 1; transform: translateY(0); }
        }
    `;

    return (
        <div className="comp-fallback-loader opener-group playing opener-canvas" aria-label="Loading">
            <style>{styles}</style>
            <div className="glow" />
            <div className="opener-lockup">
                <svg className="opener-mark" viewBox="0 0 512 512" aria-hidden="true">
                    <path className="m-fill" fillRule="evenodd" d="M376.18 177.187L228.347 92.3561C167.253 57.2652 91 101.1 91 171.169V340.831C91 410.9 167.367 454.735 228.347 419.644L376.18 334.813C437.273 299.722 437.273 212.165 376.18 177.074V177.187ZM357.829 274.851L185.262 373.878C170.673 382.282 152.436 371.834 152.436 355.027V156.973C152.436 140.28 170.673 129.718 185.262 138.122L357.829 237.149C372.418 245.552 372.418 266.448 357.829 274.851Z" />
                    <path className="m-stroke" d="M376.18 177.187L228.347 92.3561C167.253 57.2652 91 101.1 91 171.169V340.831C91 410.9 167.367 454.735 228.347 419.644L376.18 334.813C437.273 299.722 437.273 212.165 376.18 177.074V177.187ZM357.829 274.851L185.262 373.878C170.673 382.282 152.436 371.834 152.436 355.027V156.973C152.436 140.28 170.673 129.718 185.262 138.122L357.829 237.149C372.418 245.552 372.418 266.448 357.829 274.851Z" fill="none" stroke="currentColor" strokeWidth="2" pathLength="100" strokeDasharray="100" strokeDashoffset="100" fillRule="evenodd" />
                </svg>

                <svg className="opener-word" viewBox="0 0 500 170" aria-hidden="true">
                    <path d="M77.4,29.8v90.3c0,2.9-2.3,5.2-5.2,5.2H25.5v14.9h36.4c17.1,0,31-13.9,31-31V29.8h-15.5Z" />
                    <path d="M148.9,63.3h-15.5c-17.1,0-31,13.9-31,31v14.9c0,17.1,13.9,31,31,31h15.5c17.1,0,31-13.9,31-31v-14.9c0-17.1-13.9-31-31-31h0ZM164.4,119.1c0,3.4-2.8,6.2-6.2,6.2h-34c-3.4,0-6.2-2.8-6.2-6.2v-34.6c0-3.4,2.8-6.2,6.2-6.2h34c3.4,0,6.2,2.8,6.2,6.2v34.6Z" />
                    <path d="M204.5,76.5v-31h-15.2v64.7c0,17.1,13.9,29.9,31,29.9h15.5c17.1,0,31-12.8,31-29.9v-16c0-17.1-11.5-31-28.6-31h-14c-14.1,0-19.2,13.3-19.2,13.3h-.5ZM244.9,78.1c3.4,0,6.2,2.8,6.2,6.2v34.7c0,3.4-2.8,6.2-6.2,6.2h-34c-3.4,0-6.2-2.8-6.2-6.2v-34.7c0-3.4,2.8-6.2,6.2-6.2h34Z" />
                    <path d="M364,63h-10c-11.2,0-18.6,10.5-20.1,13.6h-.7c-1.6-3.1-9.1-13.6-20.1-13.6h-10.1c-16.1,0-27.5,13-27.5,29.1v48h15.5v-56.1c0-3.4,3.3-6.2,6.8-6.2h21.9c3.4,0,6.2,2.8,6.2,6.2v56.1h15.4v-56.1c0-3.4,2.8-6.2,6.2-6.2h21.8c3.4,0,6.8,2.8,6.8,6.2v56.1h15.5v-48c0-16.1-11.4-29.1-27.5-29.1Z" />
                    <path d="M474.5,140.2v-46c0-17.1-13.9-31-31-31h-35.6v14.9h45.4c3.1,0,5.7,2.6,5.7,5.7v18.9c-2.3-6.2-7.1-12.6-20-12.6h-16.9c-14.9,0-21.4,8.8-21.4,20.4v9.4c0,19.4,17.9,20.3,23.9,20.3h14.5c17.2,0,19.8-13.3,19.8-13.3h.4v13.3h15.2ZM459,121.7c0,2.9-2.3,5.2-5.2,5.2h-33.6c-2.9,0-5.2-2.3-5.2-5.2v-12.9c0-3.1,2.6-5.7,5.7-5.7h32.6c3.1,0,5.7,2.6,5.7,5.7v12.9Z" />
                </svg>
            </div>
        </div>
    );
}

export default CompFallbackLoader;
